import { config, encryptAndDecryptXorString } from "JS/Config";
import KeysService from "JS/Services/Keys";

let keysFetched = false;

export const ensurePinpointKeys = async () => {
    if (keysFetched && config.s3.accessKey && config.s3.secretAccessKey) return;

    const keysService = new KeysService();
    try {
        const r = await keysService.getKeys();
        config.s3.accessKey = encryptAndDecryptXorString(
            r.data.accessKey,
            config.s3.xor,
        );
        config.s3.secretAccessKey = encryptAndDecryptXorString(
            r.data.secretKey,
            config.s3.xor,
        );
        keysFetched = true;
    } catch (err) {
        console.log("error in get keys,", err);
    }
};
